import service from '../../api';

export default {
    store(data) {
        return service.post('/checkout/store', data);
    },
    retrieve() {
        return service.get('/checkout/store');
    },
    clear() {
        return service.get('/checkout/clear');
    }
}
